<style></style>

<template>
    <BContainer>
        <BRow>
            <BCol>
                <h2>Are your programs already using Go NAPSACC?</h2>
                <p>
                    To connect with a program, check the box and then click the orange "Add Program" button. Registered programs in your region are listed below. Sort by program name, type or county - or just start typing in the blue search box.
                </p>
            </BCol>
        </BRow>
        <BRow>
            <form action="connections/request-to-connect" method="POST" style="width:100%">
                <input type="hidden" name="_token" :value="token">
                <div class="table-template">
                    <BFormGroup horizontal label="Filter" class="d-md-none not-generic-form">
                        <BInputGroup>
                            <BFormSelect v-model="sortBy" :options="sortFields">
                                <option slot="first" :value="null">-- Filter --</option>
                            </BFormSelect>
                            <BFormSelect :disabled="!sortBy" v-model="sortDesc" slot="append">
                                <option :value="false">Asc</option>
                                <option :value="true">Desc</option>
                            </BFormSelect>
                        </BInputGroup>

                        <div class="border-search">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="filter" placeholder="Search by County or Program Name" />
                                <div class="input-group-append">
                                    <i class="fa fa-search my-auto"></i>
                                </div>
                            </div>
                        </div>
                    </BFormGroup>

                    <div class="row rounded-top find-program">
                        <div class="arrow-find-program">
                            <img src="~public@/images/orange_arrow_blue_border.png">
                            <span class="table-title">&nbsp;Find a Registered Program</span>
                        </div>
                        <div class="border-search d-none d-md-block">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="filter" placeholder="Search by County or Program Name" />
                                <div class="input-group-append">
                                    <i class="fa fa-search my-auto"></i>
                                </div>
                            </div>
                        </div>
                    </div> 

                    <BTable
                        hover
                        stacked="md" 
                        :fields="fields" 
                        v-if="programs.length"
                        :items="programs"
                        :filter="filter"
                        @filtered="onFiltered"
                        :sort-by.sync="sortBy" 
                        :sort-desc.sync="sortDesc"
                        :current-page="currentPage" 
                        :per-page="perPage"
                        show-empty
                    >
                        <span slot="empty">
                                {{ (loading) ? 'Loading...' : 'Did not find the program you are looking for? Invite them to join Go NAPSACC with the form below.' }}
                        </span>
                        <template v-slot:cell(action)="{item}">
                            <div class="form-check" v-if="item.status == 'Not Connected'">
                            <input type="checkbox" class="form-check-input" :id="item.id" :name="item.id">
                            <label class="form-check-label" :for="item.id">Invite</label>
                            </div>
                        </template>
                    </BTable>

                    <div class="row pagination-row">
                        <div class="connect-button-div">
                            <button type="submit" class="btn btn-orange-blue">Connect</button>
                        </div>
                        <BPagination :total-rows="this.programs.length" :per-page="perPage" v-model="currentPage" hide-goto-end-buttons />
                    </div>
                </div>
            </form>
        </BRow>
    </BContainer>
</template>

<script>
    export default {
        props: {
            token: {
                required: true,
                type: String
            }
        },
        data() {
            return {
                programs: [],
                filter: null,
                fields: [
                    {
                        key: 'status',
                        label: 'Status',
                        sortable: true
                    },
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'partner',
                        label: 'Partner',
                        sortable: true
                    },
                    {
                        key: 'county',
                        label: 'County',
                        sortable: true
                    },
                    {
                        key: 'state',
                        label: 'State',
                        sortable: true,
                        'class': 'state-col'
                    },
                    {
                        key: 'action',
                        label: 'action',
                        sortable: false,
                        'class': 'action-col'
                    },
                ],
                currentPage: 1,
                perPage: 5,
                sortBy: null,
                sortDesc: false,
                loading: false
            }
        },
        methods:{
            onFiltered (filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
        },
        computed: {
            sortFields: function () {
                if (this.fields) {
                    return this.fields
                        .filter(f => f.sortable)
                        .map(f => { return { text: f.label, value: f.key } })
                }
                return new Array();
            }
        },
        mounted: function(){
          this.loading = true;
            axios.get('/api/consultants/programs')
                .then(response => {

                    this.programs = response.data.data;
                    return response;
                })
                .catch(error => {
                  console.error(error);
                  return error;
                })
                .then(() => {
                  this.loading = false;
                })
        }
    }
</script>